export const POST = async (resource, headers, raw) => {
  var myHeaders = new Headers();

  for (const [key, value] of Object.entries(headers)) {
      myHeaders.append(key, value);
  }

  var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
  };

  return fetch(resource, requestOptions);
};